(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  function isDesktopHeaderContrast() {
    return window.matchMedia('(min-width: 67.5em)').matches;
  }

  function resetHeaderContrast(header) {
    var defaultTheme = header.getAttribute('data-default-theme');

    header.classList.remove('c-header--light', 'c-header--dark');

    if (header.classList.contains('is-transparent') && defaultTheme) {
      header.classList.add('c-header--' + defaultTheme);
    }
  }

  function updateHeroBackground(header) {
    if (!header.classList.contains('is-transparent')) return;

    var hero = document.querySelector('[data-header-theme]');
    if (!hero) return;

    var bar = document.querySelector('[data-header]') || header;
    var barBottom = bar.getBoundingClientRect().bottom;
    var heroBottom = hero.getBoundingClientRect().bottom;

    header.classList.toggle('c-header--past-hero', heroBottom <= barBottom);
  }

  function updateHeaderContrast(header) {
    if (!header.classList.contains('is-transparent')) return;
    if (header.classList.contains('c-header--past-hero')) {
      header.classList.remove('c-header--light', 'c-header--dark');
      return;
    }
    if (!isDesktopHeaderContrast()) {
      resetHeaderContrast(header);
      return;
    }

    var bar = document.querySelector('[data-header]') || header;
    var barBottom = bar.getBoundingClientRect().bottom;
    var probeY = Math.max(barBottom - 1, 1);
    var sections = document.querySelectorAll('[data-header-theme]');
    var currentTheme = null;

    sections.forEach(function (section) {
      var rect = section.getBoundingClientRect();

      if (rect.top <= probeY && rect.bottom > probeY) {
        currentTheme = section.getAttribute('data-header-theme');
      }
    });

    if (!currentTheme) return;

    header.classList.remove('c-header--light', 'c-header--dark');
    header.classList.add(currentTheme === 'dark' ? 'c-header--light' : 'c-header--dark');
  }

  function computeImageLuminance(img) {
    var canvas = document.createElement('canvas');
    var w = 20;
    var h = 20;
    canvas.width = w;
    canvas.height = h;

    var ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, w, h);

    var data;
    try {
      data = ctx.getImageData(0, 0, w, h).data;
    } catch (e) {
      // Canvas tainted by cross-origin image without proper CORS headers.
      return null;
    }

    var total = 0;
    var count = 0;

    for (var i = 0; i < data.length; i += 4) {
      total += (0.2126 * data[i] + 0.7152 * data[i + 1] + 0.0722 * data[i + 2]) / 255;
      count++;
    }

    return count ? total / count : null;
  }

  function applyImageContrast(section, header) {
    var el = section.querySelector('img');
    if (!el) return;

    var src = el.currentSrc || el.getAttribute('src') || el.getAttribute('data-src');
    if (!src || src.indexOf('data:') === 0) return;

    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      var luminance = computeImageLuminance(probe);
      if (luminance === null) return;

      // Luminance close to 1 = bright/light background -> black text.
      // Luminance close to 0 = dark background -> white text.
      section.setAttribute('data-header-theme', luminance > 0.6 ? 'light' : 'dark');
      updateHeaderContrast(header);
    };
    probe.src = src;
  }

  function initImageContrast(header) {
    if (!isDesktopHeaderContrast()) return;

    document.querySelectorAll('[data-header-theme]').forEach(function (section) {
      applyImageContrast(section, header);
    });
  }

  function watchMobileNav(header) {
    var nav = document.querySelector('nav-mobile[data-nav]');
    if (!nav) return;

    var sync = function () {
      header.classList.toggle('c-header--menu-open', nav.classList.contains('is-open'));
    };

    new MutationObserver(sync).observe(nav, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  function initHeaderContrast() {
    var header = document.querySelector('[data-component="header"]');
    if (!header) return;

    var ticking = false;
    var requestUpdate = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateHeroBackground(header);
        updateHeaderContrast(header);
        ticking = false;
      });
    };

    updateHeroBackground(header);
    updateHeaderContrast(header);
    initImageContrast(header);
    watchMobileNav(header);

    // Mobile browsers can resize the viewport mid-scroll (address bar
    // collapsing) and layout can shift slightly after initial paint
    // (webfonts, images), so we re-check a couple more times early on
    // in addition to scroll/resize/touchmove.
    window.setTimeout(requestUpdate, 300);
    window.setTimeout(requestUpdate, 1000);

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    window.addEventListener('touchmove', requestUpdate, { passive: true });
    window.addEventListener('orientationchange', requestUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderContrast);
  } else {
    initHeaderContrast();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strate-care-hero-cards"] && !Shopify.designMode) return;
  try {
    
	function initCareCards() {
		var roots = document.querySelectorAll('[data-care]')

		roots.forEach(function (root) {
			var buttons = root.querySelectorAll('[data-care-card-select]')
			var panels = root.querySelectorAll('[data-care-hero-panel]')

			buttons.forEach(function (button) {
				button.addEventListener('click', function () {
					var index = button.getAttribute('data-card-index')

					panels.forEach(function (panel) {
						var isActive = panel.getAttribute('data-card-index') === index
						panel.classList.toggle('u-hidden', !isActive)
					})
				})
			})
		})
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initCareCards)
	} else {
		initCareCards()
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strate-story-sticky"] && !Shopify.designMode) return;
  try {
    
  function updateStoryStickyState(section) {
    var gallery = section.querySelector('.c-story-sticky__gallery');
    var stickyEl = section.querySelector('.c-story-sticky__text-sticky');

    if (!gallery || !stickyEl) return;

    var isShorterThanViewport = gallery.offsetHeight < window.innerHeight;

    stickyEl.classList.toggle('is-not-sticky', isShorterThanViewport);
  }

  function initStoryStickyBlocks() {
    var sections = document.querySelectorAll('.c-story-sticky');

    sections.forEach(function (section) {
      updateStoryStickyState(section);
    });
  }

  window.addEventListener('resize', initStoryStickyBlocks);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStoryStickyBlocks);
  } else {
    initStoryStickyBlocks();
  }

  } catch(e) { console.error(e); }
})();
})();
